/* ======================================================================
   MAPA VIVO (3-sep-2026)

   El sitio cobra y muestra precios con un mapa que hasta hoy venia congelado
   dentro del tema (pc-conexion) y habia que regenerar a mano cada vez que
   cambiaba algo en Shopify. Este guion lo lee de Shopify EN CADA CARGA:

     1. Si hay un mapa guardado en el navegador (menos de 24 h), lo pone en
        pc-conexion antes de que arranquen los modulos que lo leen. Asi la
        pagina abre al instante con lo ultimo que se vio.
     2. Pregunta a la Storefront API (misma llave publica que usa layering),
        reconstruye el mapa con la MISMA logica que rehacer_mapa_nube.py y lo
        guarda.
     3. Si no habia mapa guardado, los modulos esperan la respuesta (maximo
        2.5 s) y arrancan con datos frescos. Si lo habia y Shopify trae algo
        distinto (un precio, una publicacion), guarda lo nuevo y recarga UNA
        vez para que todo el sitio quede parejo.
     4. Si Shopify no responde, se queda con el mapa del tema. Nunca se queda
        sin precios.

   Los nombres de difusores se sincronizan desde Shopify (R67).
   Lo que sigue siendo del sitio: notas, escenas y fotos. Eso no
   cambia desde Shopify.
   ====================================================================== */
(function(){
  "use strict";
  var TOKEN = "7d64e957478ff08d8a172591a06a20b9";
  var API = "https://velantis.mx/api/2024-10/graphql.json";
  var LLAVE = "velantis_mapa_vivo", TTL = 24 * 3600 * 1000, ESPERA_MAX = 10000; /* 4-sep: 10 s desde DOMContentLoaded; las secciones ya no esperan y una recarga de 15 MB cuesta mas que esperar */
  var DF = {"Scent Diffuser 3000":"DF002","Vertical Smart Diffuser":"DF003","Scent Diffuser 300":"DF004",
            "M22 Diffuser":"DF005","Aroma Diffuser":"DF006","Portable Plug-in Diffuser":"DF007"};
  var CLAVES = ["variantes","precios","variantes50","precios50","bolsillo","aceites","difusores","difusorAromas","sin_variante"];

  var nodo = document.getElementById("pc-conexion");
  var nodoLp = document.getElementById("lp-cfg");
  var lector = document.currentScript;
  var soloLectura = !!(lector && lector.dataset.soloLectura === "true") || (!nodo && !!nodoLp);
  if(!nodo && !nodoLp && !soloLectura) return;
  if(soloLectura){
    try{
      if(window.parent !== window && window.parent.MAPA_VIVO && window.parent.MAPA_VIVO.comercial){
        window.MAPA_VIVO = window.parent.MAPA_VIVO;
        return;
      }
    }catch(e){}
  }

  function canon(s){ var t = String(s || "").trim().toUpperCase(); var m = /^V0*(\d+)$/.exec(t); return m ? "V" + m[1].padStart(3,"0") : t; }
  function leerJSON(n){ try{ return JSON.parse(n.textContent) || {}; }catch(e){ return {}; } }
  function firma(cx){ var o = {}; CLAVES.forEach(function(k){ o[k] = cx[k]; }); return JSON.stringify(o); }
  function ahora(){ return Date.now(); }

  /* ---------------------------------------------------------- memoria */
  if(window.Shopify && Shopify.theme && Shopify.theme.role !== "main") LLAVE += ":preview:"+Shopify.theme.id;
  if(window.Shopify && Shopify.theme ? Shopify.theme.role !== 'main' : new URL(document.baseURI).searchParams.has('preview_theme_id')) LLAVE += ':altas12-r82-snapshot';
  var cache = null;
  if(!soloLectura){
  try{ var c = JSON.parse(localStorage.getItem(LLAVE) || "null"); if(c && c.t && ahora() - c.t < TTL) cache = c; }catch(e){}
  }
  function guardar(cx, tallas){ try{ localStorage.setItem(LLAVE, JSON.stringify({t: ahora(), cx: cx, tallas: tallas})); }catch(e){} }

  function inyectar(cx, tallas){
    if(nodo && cx){ var base = leerJSON(nodo); CLAVES.forEach(function(k){ if(cx[k] !== undefined) base[k] = cx[k]; }); nodo.textContent = JSON.stringify(base); }
    if(nodoLp && tallas){ var cfg = leerJSON(nodoLp); if(cfg.tienda){ cfg.tienda.tallas = tallas; nodoLp.textContent = JSON.stringify(cfg); } }
  }
  var arrancoConCache = false;
  if(cache){ inyectar(cache.cx, cache.tallas); arrancoConCache = true; }

  /* ---------------------------------------------------------- Shopify */
  function gql(query, variables){
    return fetch(API, {method:"POST", headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":TOKEN},
                       body: JSON.stringify({query:query, variables:variables || {}})})
      .then(function(r){ return r.json(); }).then(function(d){ if(d.errors) throw new Error(d.errors[0].message); return d.data; });
  }
  var Q = "query($c:String,$r:Boolean!){ products(first:250, after:$c,sortKey:ID,reverse:$r){ pageInfo{ hasNextPage endCursor } nodes{ id title productType onlineStoreUrl featuredImage{ url } variants(first:25){ nodes{ id title sku price{ amount } availableForSale } } } } }";
  function todos(){
    var acc = [],tail=[],tailIds={};
    function pagina(c){return gql(Q,{c:c,r:false}).then(function(d){var page=d.products;acc=acc.concat(page.nodes);if(!page.pageInfo.hasNextPage||page.nodes.some(function(p){return tailIds[p.id];}))return acc.concat(tail);return pagina(page.pageInfo.endCursor);});}
    function catalogo(){return Promise.all([gql(Q,{c:null,r:false}),gql(Q,{c:null,r:true})]).then(function(data){var first=data[0].products;acc=first.nodes;tail=data[1].products.nodes.slice().reverse();tail.forEach(function(p){tailIds[p.id]=true;});return (!first.pageInfo.hasNextPage||acc.some(function(p){return tailIds[p.id];}))?acc.concat(tail):pagina(first.pageInfo.endCursor);}).then(function(products){var seen={};return products.filter(function(p){if(seen[p.id])return false;seen[p.id]=true;return true;});});}
    function catalogoWorker(){
      if(typeof Worker==='undefined')return catalogo();
      return new Promise(function(resolve,reject){
        var fn=function(e){var config=e.data;
          function page(range,cursor){return fetch(config.api,{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':config.token},body:JSON.stringify({query:config.query,variables:{c:cursor,q:range}})}).then(function(r){if(!r.ok)throw Error('Catalogue request failed');return r.json();}).then(function(d){if(d.errors)throw Error('Catalogue query failed');var p=d.data.products;return p.pageInfo.hasNextPage?page(range,p.pageInfo.endCursor).then(function(next){return p.nodes.concat(next);}):p.nodes;});}
          Promise.all(config.ranges.map(function(range){return page(range,null);})).then(function(groups){var products=[],seen={};groups.forEach(function(group){group.forEach(function(p){if(!seen[p.id]){seen[p.id]=true;products.push(p);}});});products.sort(function(a,b){return Number(a.id.split('/').pop())-Number(b.id.split('/').pop());});postMessage({products:products});},function(){postMessage({error:true});});
        };
        var url=URL.createObjectURL(new Blob(['onmessage='+fn.toString()],{type:'text/javascript'})),worker;
        function done(){clearTimeout(timer);if(worker)worker.terminate();URL.revokeObjectURL(url);}
        var timer=setTimeout(function(){done();reject(Error('Catalogue worker timeout'));},12000);
        try{worker=new Worker(url);worker.onmessage=function(e){done();if(e.data.error)reject(Error('Catalogue worker failed'));else{window.VelantisCatalogWorker62=true;resolve(e.data.products);}};worker.onerror=function(){done();reject(Error('Catalogue worker unavailable'));};worker.postMessage({api:new URL(API,location.href).href,token:TOKEN,query:"query($c:String,$q:String){products(first:250,after:$c,sortKey:CREATED_AT,query:$q){pageInfo{hasNextPage endCursor}nodes{id title productType onlineStoreUrl featuredImage{url}variants(first:25){nodes{id title sku price{amount}availableForSale}}}}}",ranges:["created_at:<'2026-04-08T18:04:43Z'", "created_at:>='2026-04-08T18:04:43Z' created_at:<'2026-05-26T19:22:52Z'", "created_at:>='2026-05-26T19:22:52Z'"]});}catch(e){done();reject(e);}
      }).catch(function(){return catalogo();});
    }

    return window.VelantisLiveProductsPromise||(window.VelantisLiveProductsPromise=catalogoWorker());
  }

  /* --------------------------------------------- reconstruir el mapa */
  function tallasDe(productos){
    var tallas = {"100":{variantes:{}, precios:{}, lista:590}, "50":{variantes:{}, precios:{}, lista:390}};
    productos.forEach(function(p){ if(p.productType !== "Perfume" || !p.onlineStoreUrl) return;
      p.variants.nodes.forEach(function(v){ var s = canon(v.sku); if(!s || !v.availableForSale) return; var b = canon(s.replace(/-50$/, "").replace(/-30$/, ""));
        if(v.title === "100 ml" && !/-50$|-30$/.test(s)){ tallas["100"].variantes[b] = v.id.split("/").pop(); tallas["100"].precios[b] = +v.price.amount; }
        else if(v.title === "50 ml"){ tallas["50"].variantes[b] = v.id.split("/").pop(); tallas["50"].precios[b] = +v.price.amount; } }); });
    return tallas;
  }

  function construir(productos, base){
    if(window.VelantisNombres)window.VelantisNombres.actualizar(productos);
    var porSku = {}, todosSku = {}, por50 = {}, por30 = {}, aromas = {}, difusor = null;
    productos.forEach(function(p){
      if(!p.onlineStoreUrl) return;                     /* sin URL no se puede cobrar por enlace */
      if(p.productType === "Aroma difusor"){
        var m = /^AR\d+\s+(.*?)\s+·\s+Aroma/.exec(p.title || ""); var nom = m ? m[1].trim() : (p.title || "").trim();
        aromas[nom] = {}; p.variants.nodes.forEach(function(v){ if(v.availableForSale) aromas[nom][v.title] = [v.id.split("/").pop(), +v.price.amount]; });
        return;
      }
      if(p.productType === "difusor de fragancias" && p.variants.nodes.some(function(v){return /^D\d{3}$/.test(String(v.sku||""));})){
        difusor = {}; p.variants.nodes.forEach(function(v){ if(v.availableForSale) difusor[v.title] = [v.id.split("/").pop(), +v.price.amount]; });
      }
      p.variants.nodes.forEach(function(v){
        var s = canon(v.sku); if(!s || !v.availableForSale) return;
        if(/^\d{3}$/.test(s)) s = "V" + s;
        var id = v.id.split("/").pop(), pr = +v.price.amount;
        if(/-50$/.test(s) || v.title === "50 ml"){ por50[s.replace(/-50$/, "")] = [id, pr]; return; }
        if(/-30$/.test(s) || v.title === "30 ml"){ por30[s.replace(/-30$/, "")] = id; return; }
        (todosSku[s] = todosSku[s] || []).push(p.title);
        if(!porSku[s]) porSku[s] = [id, pr, p.title];
      });
    });
    /* un codigo en dos productos distintos no se adivina: se retira */
    Object.keys(todosSku).forEach(function(s){ var t = {}; todosSku[s].forEach(function(x){ t[x] = 1; }); if(Object.keys(t).length > 1){ delete porSku[s]; delete por50[s]; delete por30[s]; } });

    var CAT = window.VELANTIS_CAT || [];
    var skuDe = {}; CAT.forEach(function(f){ if(f && f[0] && f[12]) skuDe[f[0]] = canon(f[12]); });
    var antes = base.variantes || {}, preciosAntes = base.precios || {};
    var nuevas = {}, precios = {};
    var candidatos = Object.keys(antes).slice(); Object.keys(skuDe).forEach(function(n){ if(!(n in antes)) candidatos.push(n); });
    var idsDePerfume = {}; Object.keys(skuDe).forEach(function(n){ var e = porSku[skuDe[n]]; if(e) idsDePerfume[e[0]] = 1; });
    candidatos.forEach(function(n){
      var s = skuDe[n];
      if(s && porSku[s]){ nuevas[n] = porSku[s][0]; precios[n] = porSku[s][1]; }
      else if(s){ /* retirado: su codigo no esta o no se vende */ }
      else if(n in antes){ var vid = antes[n]; if(!idsDePerfume[vid]){ nuevas[n] = vid; precios[n] = preciosAntes[n] || 0; } }
    });
    /* podar lo que no existe en el sitio */
    var enSitio = {}; CAT.forEach(function(f){ if(f && f[0]) enSitio[f[0]] = 1; }); Object.keys(window.VELANTIS_LHS || {}).forEach(function(k){ enSitio[k] = 1; });
    Object.keys(nuevas).forEach(function(n){ if(!enSitio[n]) { delete nuevas[n]; delete precios[n]; } });
    /* difusores */
    var difusores = [];
    Object.keys(DF).forEach(function(n){ var e = porSku[DF[n]]; if(e){ nuevas[n] = e[0]; precios[n] = e[1]; difusores.push(n); } });
    var difusorAromas = {};
    if(difusor && Object.keys(difusor).length){
      difusores.unshift("Velantis Diffuser"); difusorAromas["Velantis Diffuser"] = Object.keys(difusor);
      Object.keys(difusor).forEach(function(a){ nuevas["Velantis Diffuser · " + a] = difusor[a][0]; precios["Velantis Diffuser · " + a] = difusor[a][1]; });
      /* 4-sep: precio base de la tarjeta = el menor entre sus aromas */
      precios["Velantis Diffuser"] = Math.min.apply(null, Object.keys(difusor).map(function(a){ return difusor[a][1]; }));
    }
    /* tallas y frasco de bolsillo */
    var v50 = {}, p50 = {}, bols = {};
    Object.keys(nuevas).forEach(function(n){ var s = skuDe[n]; if(!s) return; if(por50[s]){ v50[n] = por50[s][0]; p50[n] = por50[s][1]; } if(por30[s]) bols[n] = por30[s]; });
    /* aceites */
    var aceites = [];
    Object.keys(aromas).forEach(function(nom){ var t = aromas[nom]; if(!t["100 ml"]) return; aceites.push(nom);
      Object.keys(t).forEach(function(tam){ nuevas[nom + " · Aceite " + tam] = t[tam][0]; precios[nom + " · Aceite " + tam] = t[tam][1]; });
      if(!(nom in nuevas)){ nuevas[nom] = t["100 ml"][0]; precios[nom] = t["100 ml"][1]; } });
    aceites.sort();
    var sinVariante = []; CAT.forEach(function(f){ if(f && f[0] && !(f[0] in nuevas)) sinVariante.push({sku: skuDe[f[0]] || "", nombre: f[0]}); });
    /* mapa de la pagina de layering: por codigo base */
    var tallas = tallasDe(productos);
    return { cx: {variantes:nuevas, precios:precios, variantes50:v50, precios50:p50, bolsillo:bols, aceites:aceites, difusores:difusores, difusorAromas:difusorAromas, sin_variante:sinVariante}, tallas: tallas };
  }

  /* Consumidores de catálogo: misma consulta, sin caché CX ni recarga. */
  if(soloLectura){
    var productosLectura = todos();
    var comercialLectura = productosLectura.then(function(productos){
      if(window.VelantisNombres)window.VelantisNombres.actualizar(productos);
      var tallas = tallasDe(productos);
      window.MAPA_VIVO.tallas = tallas;
      window.MAPA_VIVO.estado = "shopify";
      window.MAPA_VIVO.fecha = ahora();
      if(nodoLp) inyectar(null,tallas);
      return {productos:productos,tallas:tallas};
    });
    window.MAPA_VIVO = {listo:comercialLectura,comercial:comercialLectura,productos:productosLectura,
      estado:"cargando",fecha:null,tallas:null,soloLectura:true};
    comercialLectura.catch(function(e){ window.MAPA_VIVO.error = String(e && e.message || e); });
    return;
  }

  /* ------------------------------------------------------- arranque
     Regla: los modulos leen el mapa UNA vez, al arrancar. Por eso aqui se
     recuerda con que firma arrancaron (firmaAplicada). Si Shopify responde
     despues y trae otra cosa, se guarda y se recarga UNA vez (marca por
     firma completa, no por su largo: $589 -> $590 no cambia el largo). */
  var resolver, listo = new Promise(function(r){ resolver = r; }), firmaAplicada = null;
  function hash(t){ var h = 5381; for(var i = 0; i < t.length; i++) h = ((h << 5) + h + t.charCodeAt(i)) | 0; return (h >>> 0).toString(36) + ":" + t.length; }
  function arrancar(){ if(firmaAplicada !== null) return; firmaAplicada = firma(nodo ? leerJSON(nodo) : {}); resolver(); }
  window.MAPA_VIVO = { listo: listo, estado: arrancoConCache ? "memoria" : "tema", fecha: cache ? cache.t : null, tallas: cache ? cache.tallas : null, soloLectura:false };
  if(arrancoConCache) arrancar();                       /* los modulos arrancan ya, con lo guardado */
  /* 4-sep: la espera se cuenta desde que la pagina termino de leerse (es de
     15 MB y tarda varios segundos). Contada desde el arranque del guion, el
     plazo vencia antes de terminar de leerla y casi toda primera visita
     arrancaba con el mapa del tema y luego recargaba: doble carga. */
  var temporizador = null;
  function vencer(){ if(window.MAPA_VIVO.estado === "tema") window.MAPA_VIVO.estado = "tema (Shopify tardo; se recarga al llegar)"; arrancar(); }
  function contar(){ if(firmaAplicada === null && !temporizador) temporizador = setTimeout(vencer, ESPERA_MAX); }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", contar); else contar();

  var baseTema = nodo ? leerJSON(nodo) : {};
  var cargaProductos = todos();
  window.MAPA_VIVO.productos = cargaProductos;
  window.MAPA_VIVO.comercial = cargaProductos.then(function(productos){
    var tallas = tallasDe(productos);
    window.MAPA_VIVO.tallas = tallas;
    return {productos:productos,tallas:tallas};
  });
  window.MAPA_VIVO.comercial.catch(function(){});
  cargaProductos.then(function(productos){
    var r = construir(productos, baseTema), nuevaFirma = firma(r.cx);
    guardar(r.cx, r.tallas);
    clearTimeout(temporizador);
    if(firmaAplicada === null){                          /* llego a tiempo: los modulos arrancan con Shopify */
      inyectar(r.cx, r.tallas); window.MAPA_VIVO.estado = "shopify"; window.MAPA_VIVO.fecha = ahora(); arrancar();
      /* 4-sep: la ficha de coleccion (#/lhs/...) no es modulo diferido: si la URL
         ya la traia, se pinto con el mapa del tema antes de que llegara Shopify.
         Se le pide que se vuelva a pintar con el mapa recien inyectado. */
      if(/^#\/lhs\//.test(location.hash)){ try{ window.dispatchEvent(new HashChangeEvent("hashchange")); }catch(e){} }
      return;
    }
    if(nuevaFirma === firmaAplicada){ window.MAPA_VIVO.estado = "memoria = shopify"; window.MAPA_VIVO.fecha = ahora(); return; }
    /* los modulos arrancaron con otro mapa (cache vieja o tema): una sola recarga por firma */
    var marca = "velantis_mv_recarga", h = hash(nuevaFirma);
    try{ if(sessionStorage.getItem(marca) !== h){ sessionStorage.setItem(marca, h); window.MAPA_VIVO.estado = "recargando"; location.reload(); return; } }catch(e){}
    window.MAPA_VIVO.estado = "memoria (Shopify cambio; se aplica en la proxima carga)";
  }).catch(function(e){ clearTimeout(temporizador); window.MAPA_VIVO.error = String(e && e.message || e); arrancar(); });
})();
